import SmartLink from 'vue-routing-anchor-parser/smart-link'
import {
	isShopifyUrl
	makeShopifyUrl
	makeCBDUrl
} from 'library/services/helpers'

# Make a regex for matching PDPs
pdpRegex = /^\/products\/([\w\-]+)/

# This is only used to find CBD products on the brand site where there should
# never be hemp products; thus we don't have any special hemp handlong.
export isCBDProduct = (to, $store) ->

	# Get the PDP handle
	return false unless toHandle = to.match(pdpRegex)?[1]

	# Create an array of handles of all the CBD products
	cbdHandles = $store.state.globals.cbdProducts
		.map ({ slug }) -> slug

	# Check if the to handle is within the cbd handles
	return toHandle in cbdHandles

# Check if the route looks like a PDP route
export isProduct = (to) -> !!to.match(pdpRegex)

# Make component by destructuring vue-routing-anchor-parser version
export default {

	# Inherit defaults
	...SmartLink

	# If the "to" matches different criteria, change what anchor is rendered
	render: (create, context) ->
		{ props: { to, target }, parent: { $store } } = context
		switch

			# If a Shopify URL, make an anchor with that domain
			when to && isShopifyUrl to
				makeAnchor create, context, makeShopifyUrl to

			# Check if the link contains a CBD handle, and you're on the brand site
			# then make that link redirect to the CBD site
			when to && process.env.CMS_SITE == 'brand' && isCBDProduct to, $store
				makeAnchor create, context, makeCBDUrl to

			# Else do default smart link logic
			else SmartLink.render create, context
}

# Create a normal anchor while expecting a `to` prop
export makeAnchor = (create, context, url = null) ->
	{ data, props: { to }, children } = context
	href = url || to

	# Append the preview_theme_id if configured
	if themeId = process.env.SHOPIFY_PREVIEW_THEME_ID
		href += if href.includes '?' then '&' else '?'
		href += "preview_theme_id=#{themeId}"

	# Make the anchor tag
	create 'a', {
		...data
		attrs: { ...data.attrs, href }
	}, children
